import { useMutation } from '@urql/vue';

import { createGhostStudentMutation } from '~/graphql/documents/core';

export const useGhostStudent = () => {
  const { fetchUser, isLoggedIn, isGhostStudent, isLessonGhost, user } = useAuth();
  const { executeMutation: _createGhostStudent } = useMutation(createGhostStudentMutation);
  const { $analytics } = useNuxtApp();

  const createGhostStudent = async () => {
    try {
      const res = await _createGhostStudent({
        input: {},
      });

      if (res.error) {
        return false;
      }

      await fetchUser(true);
      $analytics.identify(user.value?.externalId ?? undefined);

      return true;
    }
    // eslint-disable-next-line unused-imports/no-unused-vars
    catch (error) {
      return false;
    }
  };

  return {
    isGhostStudent,
    isLessonGhost,
    isLoggedIn,
    createGhostStudent,
  };
};
